import type { Timezone } from '@acceligentllc/shared/enums/timezone';

export const TIMEZONE_FILTER_BY: (keyof Timezone)[] = ['name'];
